import palette from '../theme/palette';

type AvatarStyle = {
  color: string;
  backgroundColor: string;
};
const avatarStyles: AvatarStyle[] = [
  {
    color: palette.white,
    backgroundColor: palette.grey[1400]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1500]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1600]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1700]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1800]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1900]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[2000]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[2100]
  }
];

// 💡 simple hash function that returns consistent number from string

const hashString = (str: string): number => {
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
};
export const useAvatar = () => {
  const getAvatarStyle = (id?: string): Partial<AvatarStyle> => {
    if (!id || typeof id !== 'string') return {};
    if (id.trim() === '') return {};

    const index = hashString(id) % avatarStyles.length;
    return avatarStyles[index];
  };

  return {
    getAvatarStyle
  };
};
